import { Breadcrumbs as BreadcrumbsBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { LinkRouter as BaseLinkRouter } from './components/link-router';

export const Wrapper = styled(BreadcrumbsBase)`
  & > .MuiBreadcrumbs-ol > .MuiBreadcrumbs-separator {
    margin: 0 ${(p) => p.theme.spacing(0.5)};
  }
`;

export const LinkRouter = styled(BaseLinkRouter)`
  line-height: 2;
  font-weight: 400 !important;
  font-size: 10px !important;
`;
